import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  CanActivate,
} from "@angular/router";
import { map, take } from "rxjs/operators";
import { Observable } from "rxjs";
import { AuthNewService } from "src/auth/services/auth-new.service";
import { CAN_MANAGE_DATA_MANAGEMENT } from "../app.constants";

@Injectable({
  providedIn: "root",
})
export class DataManagementGuardService {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    try {
      const token = localStorage.getItem("access_token");
      if (token) {
        const tokenValue = token.split(".")[1];
        const payload = JSON.parse(atob(tokenValue));
        const email = payload["email"];
        if (email && typeof email === "string") {
          const canSee = CAN_MANAGE_DATA_MANAGEMENT.includes(
            email?.toLowerCase()
          );
          if (canSee) return true;
        }
        this.router.navigate(["/app/expenses/expenses"]);
      }
    } catch (e) {
      this.router.navigate(["/app/expenses/expenses"]);
    }
  }
}
